import { render, staticRenderFns } from "./corporateCertification.vue?vue&type=template&id=4e27b492&scoped=true"
import script from "./corporateCertification.vue?vue&type=script&lang=js"
export * from "./corporateCertification.vue?vue&type=script&lang=js"
import style0 from "./corporateCertification.vue?vue&type=style&index=0&id=4e27b492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e27b492",
  null
  
)

export default component.exports